import React, { useState } from 'react'
import { Tabs } from 'components'
import TabPanel from 'components/TabPanel'
import BuildFeed from './BuildFeed'

function ApplicationLog(props) {
  const { applicationData } = props

  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (value) => {
    setActiveTab(value)
  }

  const feedURL = `/application/activity-feed?candidate_greenhouse_id=${applicationData.candidate.greenhouse_id}`
  const journalURL = `/application/journal?application_uuid=${applicationData.uuid}`
  const tabs = [{ label: "Atualizações de Campos" }, { label: "Greenhouse's Feed" }]

  return (
    <div>
      <Tabs
        tabs={tabs}
        onChange={handleTabChange}
      />
      <TabPanel value={activeTab} index={0}>
        <BuildFeed url={journalURL} />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <BuildFeed url={feedURL} />
      </TabPanel>
    </div>
  )
}

export default ApplicationLog
